
class Constants {
  static get productName () {
    return 'TalentNeuron Data feeds'
  }

  static get productId () {
    return 5
  }
}

export const GROUP_A_CATEGORYID = 1
export const GROUP_B_CATEGORYID = 2
export const GROUP_C_CATEGORYID = 3

export const TOKEN_REFRESH_TIME = 1750000
export const TOKEN_REFRESH_THRESHOLD_TIME = 70
export const TN_DOMAIN = 'talentneuron.com'

export const limitedCoverageFieldIds = [63, 65, 162, 163, 164]

export default Constants

export const COUNTRY_LIST_FOR_TRANSLATION = ['CN', 'JP', 'SA', 'TH', 'AE', 'HK', 'TW']

export const trackingPendoId = '78b2e650-a741-4271-a44f-1d1664a0744a'

export const translatedText = (item, countryCode) => {
  const translatedLabel = item.translation || ''
  const orginalLabel = item.label || ''
  if (countryCode && countryCode.trim() !== '' && COUNTRY_LIST_FOR_TRANSLATION.indexOf(countryCode) === -1) {
    return orginalLabel
  }
  if (!translatedLabel || !translatedLabel.trim().length) {
    return orginalLabel
  }
  if (translatedLabel.trim() === orginalLabel.trim()) {
    return orginalLabel
  }
  return translatedLabel.trim() + ' / ' + orginalLabel
}